import React from 'react'
import StepTemplate from './StepTemplate'
import { Pregunta, PREGUNTAS } from '../../data/ocean'

const CONSIGNAS: Pregunta[] = PREGUNTAS.slice(22, 33)

export default function Step3() {
  return <StepTemplate step={3} consignas={CONSIGNAS} />
}
